import { map } from 'lodash'
import moment from 'moment'

const prepareShow = parking => {
  parking.date_go_in = moment(parking.date_go_in, 'YYYYMMDD').format('YYYY-MM-DD')
  parking.date_go_out = moment(parking.date_go_out, 'YYYYMMDD').format('YYYY-MM-DD')

  return parking
}

const prepareSave = parking => {
  return parking
}

export default {
  prepareSave,
  prepareShow,
  afterCreated () {
    this.$toast.success('Locação incluido com sucesso.')
    return this.$router.push({name: 'tenant.rent.parking.index'})
  },
  afterUpdated () {
    this.$toast.success('Locação alterada com sucesso.')
    return this.$router.push({name: 'tenant.rent.parking.index'})
  },
  showActions (actions) {
    if (actions) {
      this.show = false
    } else {
      this.show = true
    }
  },
  /** Retornando as torres das uniades do dweller */
  getTowersDweller () {
    this.$http.get('/v1/dweller/towers/search')
      .then(({data}) => {
        const towers = map(data, function (item) {
          return {
            id: item.id,
            number: item.number + ' - ' + item.name
          }
        })
        this.dwellerTowers = towers
      })
  },
  /** Retornando as unidades da torre selecionada */
  selectUnitsTower (tower) {
    if (typeof tower === 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower.id)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }

    if (typeof tower !== 'object') {
      this.$http.get('/v1/dweller/units/search/' + tower)
      .then(({data}) => {
        this.dwellerUnits = data
      })
    }
  },
  getGaragesDweller (unit) {
    if (typeof unit === 'object') {
      const search = {
        unit_id: unit.id,
        tower_id: this.rent.tower_id
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
    if (typeof unit !== 'object') {
      const search = {
        unit_id: unit,
        tower_id: this.rent.tower_id
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
  },
  getGaragesDwellerEdit (unit, tower) {
    if (typeof unit !== 'object') {
      const search = {
        unit_id: unit,
        tower_id: tower
      }
      this.$http.post('/v1/dweller/garages/search', search)
        .then(({data}) => {
          this.garages = data
        })
    }
  },
  getUnits () {
    this.$http.get('/v1/dweller/search/unit')
      .then((data) => {
        this.optionUnits = data.data
      })
  },
  getTowers () {
    this.$http.get('/v1/dweller/search/tower')
      .then((data) => {
        this.optionTowers = data.data
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/rent-parking/form/resources/methods.js